<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフー覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <h3 v-show="err_catch" class="err_msg">エラー発生!!!!</h3>
        <h1>スタッフ登録内容＜差分確認＞</h1>
        <div class="search_register_btn">
            <router-link class="register_btn" to="/ubiadmin/AdminStaffEdit">CSVアップロード</router-link>
        </div>
        <div class="number">
            <p>{{ getMinPage }}〜{{ json_data.length }}／{{ json_data.length }}</p>
        </div>
        <div class="news_list_tables">
            <table>
                <tr class="header_tr">
                    <th class="small_list">管理番号</th>
                    <th class="small_list">区分</th>
                    <th>名前</th>
                    <th>メールアドレス</th>
                    <th class="small_list">登録者</th>
                    <th>登録日時</th>
                    <th class="small_list">更新者</th>
                    <th>更新日時</th>
                </tr>
            </table>
            <div class="news_list">
                <table>
                    <tr v-for="e in json_data" :key="e.id">
                        <td class="small_list">{{ e.staff_id }}</td>
                        <td
                        class="small_list"
                        v-bind:class="{'type_red': e.type=='新規','type_blue': e.type=='変更','type_green': e.type=='削除'}"
                        >{{ e.type }}</td>
                        <td
                        v-bind:class="{'type_blue': e.change_point.includes('name')}"
                        >{{ e.name }}</td>
                        <td
                        v-bind:class="{'type_blue': e.change_point.includes('email')}"
                        >{{ e.email }}</td>
                        <td class="small_list">{{ e.create_user }}</td>
                        <td>{{ e.create_date | moment("YYYY/MM/DD HH:mm:ss") }}</td>
                        <td class="small_list">{{ e.update_user }}</td>
                        <td>{{ e.update_date | moment("YYYY/MM/DD HH:mm:ss") }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="news_edit_btns">
            <router-link to="/ubiadmin/AdminStaffEdit">戻る</router-link>
            <!-- <router-link class="red" to="/AdminStaffList">登録</router-link> -->
            <button v-on:click="json_register">登録</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['json_data'],
  data () {
    return {
      err_catch: false,
      url_protcol: 'https://',
      domain: '1304kanri.ubiquitous-p.com',
      url_path: '/rest/staff_create_csv/'
    }
  },
  methods: {
    json_register () {
      axios.post(this.url_protcol + this.domain + this.url_path,{},{
          headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
      }).then(response => {
        this.$router.push({name: 'AdminStaffList'})
      }).catch(error => {
        this.err_catch = true
        console.log(error)
      })
    },
    logout() {
        this.$store.commit('reset');
        this.$router.push({name:'aLogin'});
    }
  },
  computed: {
    getMinPage: function () {
      if (this.json_data.length === 0) {
        return 0
      } else {
        return 1
      }
    }
  }
}
</script>

<style scoped>

.main {
    width: 100vw;
    background-size: cover;
}

a.register_btn {
    width: fit-content;
    display: block;
    background-color: #4DC0AD;
    color: #fff;
    border-radius: 10px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    padding: 5px 40px;
    margin-left: auto;
}

h1 {
    margin: 10px 30px;
}

.search_register_btn {
    display: flex;
    width: 95vw;
    margin: 20px auto 0;
}

.search_wrap {
    display: flex;
    align-items: center;
}

.search_wrap button {
    width: fit-content;
    display: block;
    background-color: #4DC0AD;
    color: #fff;
    border-radius: 10px;
    box-shadow: rgb(158 158 158) 1px 1px 3px;
    text-decoration: none;
    padding: 5px 40px;
    margin: 0 3vw 0 auto;
    border: none;
}

.search_wrap input {
    display: block;
    width: 250px;
    height: 30px;
    padding: 0 10px;
    border-radius: 10px;
    border: 1px solid #888;
    box-shadow: rgb(210 210 210) 1px 1px 3px inset;
}

.interval {
    margin-right: 20px;
}

.number {
    text-align: right;
    margin-right: 5vw;
}

.number p {
    font-size: .7em;
    margin: 5px 0;
}

.news_list_tables {
    width: 95vw;
    margin: 0 auto;
    padding: 20px 30px;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    box-shadow: rgb(228 228 228) 1px 1px 8px;
}

.news_list {
    width: 100%;
    height: 55vh;
    overflow: scroll;
}

table {
    width: 100%;
    border-collapse: collapse;
    position: relative;
}

td, tr, td a {
    font-size: .9vw;
}

tr {
    border-bottom: 1px solid #707070;
    height: 50px;
}

th, td {
    width: 95px;
    text-align: left;
    word-break: break-all;
}

th.small_list, td.small_list {
    width: 60px;
    text-align: center;
}

td a {
    text-decoration: underline;
    color: blue;
}

.news_edit_btns {
    display: flex;
    justify-content: space-between;
    width: 90vw;
    margin: 0 auto;
    padding: 15px;
}

.news_edit_btns a {
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
}

.news_edit_btns button {
    background: none;
    border: none;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #F37B6F;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
}

/* a.red {
    background-color: #F37B6F;
} */

.type_red {
    color: red;
}

.type_blue {
    color: blue;
}

.type_green{
    color: green;
}

.err_msg {
    color: red;
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/AdminStaffConfirm.vue